import Recognition from '../src/Recognition/index.tsx';
export default Recognition;
